import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
  fill?: string;
}

export const StarIcon: React.FC<Props> = ({
  color = theme.colors.text,
  fill = theme.colors.white,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7276 3.44418L15.4874 6.99288C15.7274 7.48687 16.3673 7.9607 16.9073 8.05143L20.0969 8.58575C22.1367 8.92853 22.6167 10.4206 21.1468 11.8925L18.6671 14.3927C18.2471 14.8161 18.0172 15.6327 18.1471 16.2175L18.8571 19.3125C19.417 21.7623 18.1271 22.71 15.9774 21.4296L12.9877 19.6452C12.4478 19.3226 11.5579 19.3226 11.0079 19.6452L8.01827 21.4296C5.8785 22.71 4.57865 21.7522 5.13859 19.3125L5.84851 16.2175C5.97849 15.6327 5.74852 14.8161 5.32856 14.3927L2.84884 11.8925C1.389 10.4206 1.85895 8.92853 3.89872 8.58575L7.08837 8.05143C7.61831 7.9607 8.25824 7.48687 8.49821 6.99288L10.258 3.44418C11.2179 1.51861 12.7777 1.51861 13.7276 3.44418Z"
      fill={fill}
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.15367 2.29604L10.3269 4.66184C10.4869 4.99116 10.9135 5.30705 11.2735 5.36754L13.3999 5.72375C14.7597 5.95227 15.0797 6.94698 14.0998 7.92825L12.4467 9.59505C12.1667 9.87732 12.0134 10.4217 12.1 10.8116L12.5733 12.8749C12.9466 14.5081 12.0867 15.1399 10.6535 14.2863L8.6604 13.0967C8.30047 12.8817 7.7072 12.8817 7.34053 13.0967L5.34745 14.2863C3.92093 15.1399 3.05437 14.5014 3.42766 12.8749L3.90094 10.8116C3.98759 10.4217 3.83428 9.87732 3.55431 9.59505L1.90116 7.92825C0.927932 6.94698 1.24123 5.95227 2.60108 5.72375L4.72751 5.36754C5.08081 5.30705 5.50743 4.99116 5.66741 4.66184L6.8406 2.29604C7.48053 1.01232 8.5204 1.01232 9.15367 2.29604Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
